export default defineNuxtPlugin(() => {
  const { $eventBus } = useNuxtApp()
  const trip = {
    change: (info: any) => {
      $eventBus.emit('trip-change', info)
    }
  }
  return {
    provide: {
      trip
    }
  }
})
